export const ProjectData = [
  {
    name: "Ranvier Core-TS",
    description: "Ranvier's core Mud engine done in TypeScript",
    projectLink: "https://github.com/Ranvier-TS/core-ts",
    githubLink: "https://github.com/Ranvier-TS/core-ts",
    image: "ranvier-ts-icon.png",
    technologies: ["RanvierMud", "NodeJS", "TypeScript"],
    techIcons: ["fab fa-ts", "fab fa-nodejs", null],
  },
  {
    name: "Exile Web Client",
    description:
      "Web Client that supports playing of the RanvierMud via websockets. Dynamically see your stats, socials, and maps extracted from the main output window. Complete with health/buff bars, party grid system, and quest windows!",
    projectLink: "https://github.com/nelsonsbrian/exile-client",
    githubLink: "https://github.com/nelsonsbrian/exile-client",
    image: "web-client-alpha8.png",
    technologies: ["RanvierMud", "React", "Redux", "SocketIO"],
    techIcons: ["fab fa-js", "fab fa-react", null],
  },
  {
    name: "Axon-OLC",
    description:
      "Online Creation editor for JSON/YAML files - Ranvier Bundle. Validates user input, cleans data, saves back to file. Allows non-developers to world build and add content in-game.",
    projectLink: "https://projects.nelsonsbrian.com/axon-olc",
    githubLink: "https://github.com/nelsonsbrian/axon-olc",
    image: "axon-olc.png",
    technologies: ["RanvierMud", "NodeJS", "EventEmitter"],
    techIcons: ["fab fa-js", "fab fa-react", null],
  },
  {
    name: "Portfolio",
    description:
      "This Webpage! The portfolio page adds all my work experience and live projects while displaying them in a neat and organized way. This site also displays the hosted content on my own server.",
    projectLink: "https://nelsonsbrian.com",
    githubLink: "https://github.com/nelsonsbrian/portfolio-splash",
    image: "portfolio.png",
    technologies: ["React", "SCSS", "Ngnix", "DigitalOcean"],
    techIcons: ["fab fa-js", "fab fa-react", null],
  },
  {
    name: "Ultimate TicTacToe",
    description:
      "A game combining 9 regular games of tic-tac-toe, albeit with new rules.",
    projectLink: "https://projects.nelsonsbrian.com/tictactoe",
    githubLink: "https://github.com/nelsonsbrian/Ultimate-TicTacToe",
    image: "tictactoe.png",
    technologies: ["JavaScript", "React", "Redux"],
    techIcons: ["fab fa-js", "fab fa-react", null],
  },
  {
    name: "Analog Clock",
    description:
      "Quick and easy analog clock that shows the date and time. It's made with React and CSS. The motion uses setInterval and CSS translate/rotate.",
    projectLink: "https://projects.nelsonsbrian.com/clock",
    githubLink: "https://github.com/nelsonsbrian/clock",
    image: "clock.png",
    technologies: ["React", "CSS"],
    techIcons: [],
  },
  {
    name: "Marvel Heroes",
    description:
      "A 2-player game that allow you to pit your favorite Marvel Studios superheroes against each other in a Mortal Combat style game.",
    projectLink: "https://projects.nelsonsbrian.com/marvel-combat",
    githubLink: "https://github.com/nelsonsbrian/Marvel-Combat",
    image: "marvelScreen2.png",
    technologies: ["JavaScript", "HTML", "CSS", "P5"],
    techIcons: ["fab fa-js", "fab fa-html5", "fab fa-css3", null],
  },
  {
    name: "Minesweeper",
    description: "Classic Game of Minesweeper. Avoid the bombs!",
    projectLink: "https://projects.nelsonsbrian.com/minesweeper",
    githubLink: "https://github.com/nelsonsbrian/MineSweeperAngular",
    image: "minesweeper2.png",
    technologies: ["JavaScript", "Angular5"],
    techIcons: ["fab fa-js", "fab fa-angular"],
  },
];
